
import React from 'react';
import { Bluetooth, BluetoothConnected } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { BluetoothDevice } from '@/types/payment';

interface BluetoothDeviceListProps {
  devices: BluetoothDevice[];
  selectedDevice: BluetoothDevice | null;
  handleConnect: (device: BluetoothDevice) => void;
}

const BluetoothDeviceList: React.FC<BluetoothDeviceListProps> = ({ devices, selectedDevice, handleConnect }) => (
  <div className="grid grid-cols-1 gap-4 animate-fade-in">
    {devices.map(device => (
      <div
        key={device.id}
        className={`device-card bg-white p-6 rounded-xl shadow-sm border border-gray-100 relative cursor-pointer transition-all hover:shadow-md ${
          selectedDevice?.id === device.id ? 'border-2 border-blue-500' : ''
        }`}
        onClick={() => handleConnect(device)}
      >
        <div className="absolute top-4 right-4">
          {selectedDevice?.id === device.id ? (
            <BluetoothConnected size={20} className="text-blue-500" />
          ) : (
            <Bluetooth size={20} className="text-gray-400" />
          )}
        </div>
        <h3 className="text-lg font-medium text-gray-800">{device.name || 'Transfer-Enabled Device'}</h3>
        <p className="text-sm text-gray-500 mt-1">{device.id.substring(0, 8)}...</p>
        <div className="flex items-center mt-2">
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
            Transfer-Enabled
          </span>
        </div>
        <button 
          className={`mt-3 px-4 py-2 rounded-full text-sm font-medium ${
            selectedDevice?.id === device.id
              ? 'bg-green-100 text-green-700'
              : 'bg-blue-50 text-blue-600 hover:bg-blue-100'
          }`}
        >
          {selectedDevice?.id === device.id ? 'Connected' : 'Connect'}
        </button>
      </div>
    ))}
  </div>
);

export default BluetoothDeviceList;
